import { format, parseISO } from "date-fns";
import { GridCellParams } from "@mui/x-data-grid";
import { useIntl } from "react-intl";

import { humanReadableDateTimeFormat } from "@dzambalaorg/constants";
import { AddressLink } from "@dzambalaorg/mui-scanner";

// prettier-ignore
export const referralReportColumnsCreator = (formatMessage: ReturnType<typeof useIntl>["formatMessage"]) =>  [
  {
    field: "id",
    headerName: formatMessage({ id: "form.labels.id" }),
    sortable: true,
    flex: 0.3
  },
  {
    field: "referrer",
    headerName: formatMessage({ id: "form.labels.referrer" }),
    sortable: false,
    renderCell: (params: GridCellParams<any, string>) => {
      return (
        <AddressLink address={params.value} length={42} />
      );
    },
    flex: 3,
    minWidth: 360
  },
  {
    field: "referral",
    headerName: formatMessage({ id: "form.labels.referral" }),
    sortable: false,
    renderCell: (params: GridCellParams<any, string>) => {
      return (
        <AddressLink address={params.value} length={42} />
      );
    },
    flex: 3,
    minWidth: 360
  },
  {
    field: "item",
    headerName: formatMessage({ id: "form.labels.item" }),
    sortable: true,
    flex: 1,
    minWidth: 100
  },
  {
    field: "price",
    headerName: formatMessage({ id: "form.labels.price" }),
    sortable: true,
    flex: 1,
    minWidth: 100
  },
  {
    field: "contract",
    headerName: formatMessage({ id: "form.labels.contract" }),
    sortable: true,
    flex: 1,
    minWidth: 100
  },
  {
    field: "event",
    headerName: formatMessage({ id: "form.labels.eventType" }),
    sortable: true,
    flex: 1,
    minWidth: 100
  },
  {
    field: "createdAt",
    headerName: formatMessage({ id: "form.labels.createdAt" }),
    sortable: true,
    valueFormatter: (value: string) => format(parseISO(value), humanReadableDateTimeFormat),
    flex: 1,
    minWidth: 160
  }
];
